import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class FormSharingModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onProceed: PropTypes.func,
    printTemplates: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    t: PropTypes.func,
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedPrintForms: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { open } = nextProps;
    if (open) {
      this.setState({ open });
    }
  }

  handleOnOpen = (e) => {
    e.preventDefault();
    this.setState({ open: true });
  }

  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
    this.setState({
      open: false,
      selectedPrintForms: [],
    });
  }

  handleInputChange = (e, { value }) => {
    const selectedTemplates = this.props.printTemplates.filter(t => value.includes(t.value));

    const selectedDocxTemplates = selectedTemplates
    .filter(t => t.type === 'docx')
    .map(t => t.value);

    const selectedPrintTemplates = selectedTemplates
    .filter(t => t.type !== 'docx')
    .map(t => t.value);

    this.setState({
      selectedDocxTemplates,
      selectedPrintTemplates,
      selectedPrintForms: value,
    });
  }

  handleProceedAndClose = (e) => {
    const { onProceed } = this.props;
    const { selectedDocxTemplates, selectedPrintTemplates } = this.state;
    const data = {
      printTemplateIDs: selectedPrintTemplates,
      docxTemplateIDs: selectedDocxTemplates,
    };
    onProceed(e, data);
    this.handleOnClose(e);
  }

  render() {
    const { t, printTemplates } = this.props;
    const { selectedPrintForms } = this.state;

    return (
      <Modal
        className="share-email"
        closeOnDimmerClick={false}
        size="tiny"
        open={this.state.open}
        onClose={this.handleOnClose}
        onOpen={this.handleOnOpen}
      >
        <Header
          icon="share square"
          content={t('Email Form to Purchaser')}
        />
        <Modal.Content>
          <div style={{ marginBottom: '40px' }}>
            <Header
              as="h5"
              style={{ margin: '0 0 5px 0' }}
            >
              {t('Select form to share with Purchaser')}
            </Header>
            <Form>
              <Form.Dropdown
                name="selectedPrintForms"
                fluid
                multiple
                search
                selection
                placeholder={t('Select form')}
                options={printTemplates}
                onChange={this.handleInputChange}
                value={selectedPrintForms}
              />
            </Form>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.handleOnClose}
            content={t('Close', { ns: TRANSLATION_FILES.translation })}
          />
          <Button
            primary
            onClick={this.handleProceedAndClose}
            content={t('Proceed', { ns: TRANSLATION_FILES.translation })}
            disabled={!selectedPrintForms.length}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(FormSharingModal);



// WEBPACK FOOTER //
// ./src/containers/modals/FormSharingModal.jsx